export default "__VITE_ASSET__BSl03gcj__";